import * as React from 'react';
import { TestProjectInputEditorStore } from '../../stores';
import { observer } from 'mobx-react-lite';
import { Radio } from 'antd';

type Props = {
    store: TestProjectInputEditorStore;
};

const inputTypeLabels = {
    Tags: 'Tags',
    Bindings: 'IOTA App Bindings',
    ProjectFields: 'Project fields'
};

const TestProjectTopicsTypeSelector: React.FC<Props> = ({ store }) => {
    const draft = store.mappingDraft;

    if (!draft) {
        return null;
    }

    const { inputSelectionStore, availableTargetInputTypes } = draft;

    // A fixed mapping destination needs a label because the user has no choice to make.
    if (availableTargetInputTypes.length === 1) {
        const [inputType] = availableTargetInputTypes;

        return <strong>{inputTypeLabels[inputType]}</strong>;
    }

    return (
        <Radio.Group
            onChange={e => store.changeMappingInputType(e.target.value)}
            value={inputSelectionStore.topicInputsType}
            disabled={!store.canEdit}
        >
            {availableTargetInputTypes.map(inputType => (
                <Radio key={inputType} value={inputType}>
                    {inputTypeLabels[inputType]}
                </Radio>
            ))}
        </Radio.Group>
    );
};

export default observer(TestProjectTopicsTypeSelector);
